import React, { ChangeEvent, useContext } from 'react'

import { Card } from '@mui/material'
import Autocomplete from '@mui/material/Autocomplete'
import Grid from '@mui/material/Grid'

import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import { ROLE_LEVEL } from 'constants/roles'
import { UserRole } from 'context/auth/types'
import FormField from 'modules/FormField'

import { UserFormContext } from '../constants'
import { User } from '../types'

function MainForm() {
	const { userForm, setUserForm } = useContext(UserFormContext)
	const { setFormEdited } = useContext(UserFormContext)
	const { showError, setIsValid } = useContext(UserFormContext)

	const roles: UserRole[] = ROLE_LEVEL.noOwner
	const handleChange = (value: any, field: keyof User) => {
		setUserForm((prev: any) => ({
			...prev,
			[field]: value,
		}))
		setFormEdited(true)
	}
	return (
		<Card id="user-details">
			<MDBox p={2}>
				<Grid container spacing={3} alignItems="center">
					<Grid item xs={12}>
						<MDBox display="flex" justifyContent="space-between" alignItems="center">
							<MDBox display="flex" flexDirection="row" gap={2} alignItems="center">
								<MDTypography variant="h5" fontWeight="medium">
									New User
								</MDTypography>
							</MDBox>
						</MDBox>
					</Grid>
					<Grid item xs={12} sm={6}>
						<MDBox display="flex" flexDirection="column" gap={1}>
							<MDTypography variant="h5" fontWeight="medium">
								Email
							</MDTypography>
							<FormField
								type="email"
								placeholder="e.g. jane@example.com"
								value={userForm.email}
								onChange={(e: ChangeEvent<HTMLInputElement>) => {
									handleChange(e.target.value, 'email')
									setIsValid(
										e.target.value.trim().length > 0 &&
											/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e.target.value)
									)
								}}
								error={
									(showError &&
										userForm.email.length > 0 &&
										!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(userForm.email)) ||
									!userForm.email.trim()
								}
								helperText={
									showError && !userForm.email.trim()
										? 'Email is required'
										: userForm.email.length > 0 &&
											  !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(userForm.email)
											? 'Enter a valid email address'
											: ''
								}
							/>
						</MDBox>
					</Grid>

					<Grid item xs={12} sm={6}>
						<MDBox display="flex" flexDirection="column" gap={1}>
							<MDTypography variant="h5" fontWeight="medium">
								Name (optional)
							</MDTypography>
							<FormField
								type="text"
								placeholder="e.g. Jane Doe"
								value={userForm.name || ''}
								onChange={(e: ChangeEvent<HTMLInputElement>) =>
									handleChange(e.target.value, 'name')
								}
								error={false}
							/>
						</MDBox>
					</Grid>

					<Grid item xs={12} sm={6}>
						<MDBox display="flex" flexDirection="column" gap={1}>
							<MDTypography variant="h5" fontWeight="medium">
								Role
							</MDTypography>
							<Autocomplete
								disableClearable
								value={userForm.role}
								options={roles}
								onChange={(_, newValue) => handleChange(newValue ?? '', 'role')}
								renderInput={params => <FormField {...params} />}
							/>
						</MDBox>
					</Grid>
				</Grid>
			</MDBox>
		</Card>
	)
}

export default MainForm
